import { DocumentType } from 'us.collection.routines-and-activities/constants';
import { DocumentDrawer } from 'us.collection.routines-and-activities/interfaces';

export const DOCUMENT_DRAWER_DEFAULT: DocumentDrawer = {
	documentType: DocumentType.UNKNOWN,
	isVisible: false,
	title: '',
	data: {},
	isXmlPdf: false,
};

export enum LogHistoryOptions {
	ALL = "all",
	CASE_LOGS = "caseLogs",
	CP_NOTES = "cpnote",
	ACTIVITIES = "messages",
	WASH_RESULTS = "washResults",
}
export enum WashResultsType {
	DATA_FACTORY = "Data Factory",
	CREDIT_SAFE = "CreditSafe"
}
export type WashResultDrawer = {
	isVisible: boolean;
	title: string;
	data: any;
};

export const WASH_RESULT_DRAWER_DEFAULT: WashResultDrawer = {
	isVisible: false,
	title: '',
	data: {}
};